// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 15:21:14
import { ListDetectorStatus_abstract } from './../../abstract/SagaSchema/ListObjects/ListDetectorStatus_abstract';
export class ListDetectorStatus extends ListDetectorStatus_abstract {}
